export default "__VITE_ASSET__Bg$nIzVQ__"